import React from 'react'
import * as R from 'ramda'
import styled from 'styled-components'
import { Segment, Button, Label } from 'semantic-ui-react'
import { Table as UnstyledTable } from 'antd'

import { fullDateTimeFormat, timestampFormat } from 'libs/date-format'
import Popup from 'shared/components/Popup'
import { NewTabLink } from 'components/NewTabLink'

const columns = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'created',
    render: (_, row) => <DateColumn row={row} />,
    width: 160,
  },
  {
    render: (_, row) => <LabelColumn row={row} />,
    width: 250,
  },
  {
    title: 'Sent',
    dataIndex: 'delivery_amount',
    key: 'delivery_amount',
    render: (data) => (data == null ? '-' : data),
  },
  {
    title: 'Opens',
    dataIndex: 'open_amount',
    key: 'open_amount',
    render: (data) => (data == null ? '-' : data),
  },
  {
    title: 'Clicks',
    dataIndex: 'click_amount',
    key: 'click_amount',
    render: (data) => (data == null ? '-' : data),
  },
]

/** @type {typeof UnstyledTable} */
const Table = styled(UnstyledTable)`
  .ant-table-footer {
    padding: 0;
    background-color: #fff;
  }

  .ant-table {
    font-size: 16px;
  }
`
export default function SendingHistory({ history, surveyId }) {
  if (R.isEmpty(history) || history === undefined) {
    return null
  }

  return (
    <Segment>
      <h4>Sending history</h4>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={history}
        pagination={history.length > 10}
        footer={() => <Footer hasData={history.length > 0} surveyId={surveyId} />}
      />
    </Segment>
  )
}

function Footer({ hasData, surveyId }) {
  if (hasData) {
    return (
      <NewTabLink to={`/dashboards/views/${surveyId}/email/`}>
        <Button className="mt3" basic>
          View email results
        </Button>
      </NewTabLink>
    )
  }
  return null
}

function DateColumn({ row }) {
  const followUpIndicator = row.email_type.startsWith('follow_up') ? '↳ ' : ''

  return (
    <Popup position="top left" tooltip={fullDateTimeFormat(row.created)}>
      <span>
        {followUpIndicator}
        {timestampFormat(row.created, 'mmm dd, yyyy')}
      </span>
    </Popup>
  )
}

function LabelColumn({ row }) {
  if (row.email_type === 'initial_email') {
    if (row.delivery_status === 'failed') {
      return (
        <Popup
          position="top left"
          tooltip={
            'Email failed to send. Check if the survey is archived or closed, or if your subscription is active.'
          }
        >
          <Label color="red">Failed</Label>
        </Popup>
      )
    }
    return null
  }

  const { color, text } = prepareLabelObj(row.email_type)
  if (row.delivery_status === 'failed') {
    return (
      <span>
        <Label color={color}>{text}</Label>
        <Popup
          position="top left"
          tooltip={
            'Email failed to send. Check if the survey is archived or closed, or if your subscription is active.'
          }
        >
          <Label color="red">Failed</Label>
        </Popup>
      </span>
    )
  }

  return <Label color={color}>{text}</Label>
}

function prepareLabelObj(email_type) {
  if (email_type === 'scheduled') {
    return { text: 'Scheduled', color: 'orange' }
  }
  if (email_type.startsWith('follow_up')) {
    return { text: 'Follow-up', color: '' }
  }

  return { text: '', color: '' }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SendingHistory/index.js